<template>
    <div class="sf__edit-selection">
        <button type="button" class="sf__edit-selection__overlay" aria-label="Close edit selection" @click="$emit('close')"></button>
        <section ref="sheet" class="sf__edit-selection__sheet" role="dialog" :aria-modal="modal ? 'true' : null" tabindex="-1" aria-label="Edit Your Vehicle">
            <header class="sf__edit-selection__header">
                <h2>Edit Your Vehicle</h2>
                <button type="button" class="sf__edit-selection__close" aria-label="Close edit selection" @click="$emit('close')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M18.3 5.71 16.89 4.29 12 9.17 7.11 4.29 5.7 5.71 10.59 10.59 5.7 15.48 7.11 16.9 12 12 16.89 16.9 18.3 15.48 13.41 10.59 18.3 5.71Z" fill="currentColor"/>
                    </svg>
                </button>
            </header>

            <div class="sf__edit-selection__body">
                <p class="sf__edit-selection__eyebrow">Current Configuration</p>

                <div class="sf__edit-selection__rows">
                    <article
                        v-for="row in rows"
                        :key="row.key"
                        class="sf__edit-selection__row"
                        :class="{ 'is-disabled': row.disabled }"
                        :aria-disabled="row.disabled ? 'true' : null"
                    >
                        <div>
                            <p class="sf__edit-selection__label">{{ row.label }}</p>
                            <p class="sf__edit-selection__value">{{ row.value }}</p>
                        </div>
                        <button
                            type="button"
                            class="sf__edit-selection__edit"
                            :disabled="row.disabled"
                            @click="$emit('edit', row.step)"
                        >
                            Edit
                        </button>
                    </article>
                </div>
            </div>

            <footer class="sf__edit-selection__footer">
                <button type="button" class="sf__edit-selection__reset" @click="$emit('changeVehicle')">
                    Change My Vehicle
                </button>
                <a v-if="showViewParts" class="sf__edit-selection__view-collection" :href="collectionUrl" @click="$emit('viewParts', $event)">
                    View Parts
                </a>
            </footer>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        modal: {
            type: Boolean,
            default: false
        },
        rows: {
            type: Array,
            default: () => []
        },
        collectionUrl: {
            type: String,
            required: true
        },
        showViewParts: {
            type: Boolean,
            default: true
        }
    },

    emits: ['close', 'edit', 'changeVehicle', 'viewParts'],

    mounted() {
        if (!this.modal) return;
        document.documentElement.classList.add('seatshop-vehicle-sheet-open');
        document.body.classList.add('seatshop-vehicle-sheet-open');
        if (window.trapFocus) window.trapFocus(this.$refs.sheet);
        else this.$refs.sheet.focus({ preventScroll: true });
    },

    beforeUnmount() {
        if (!this.modal) return;
        window.removeTrapFocus?.();
        document.documentElement.classList.remove('seatshop-vehicle-sheet-open');
        document.body.classList.remove('seatshop-vehicle-sheet-open');
    }
};
</script>
